import { WardGroupAssignment } from './ward-group-assignment.model';
import { AcademicSession } from '../util/academic-session.model';

export class WardGroupAssignments {
  campusWardId: number;
  academicSession: AcademicSession;
  campusWardGroupTypeId: number;
  semesterAssignmentsCanBeRolledFrom: AcademicSession;

  assignments: WardGroupAssignment[];

  constructor() {
    this.assignments = [];
  }
}
